import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AdminService} from "../dashboard/services/admin.service";
import {ParameterService} from "../../_services/parameter.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AdminAddNewTrainingDialog} from "./modals/admin-add-new-training.dialog";

@Component({
    selector: 'admin-upcoming-ceu',
    templateUrl: './admin-ceu.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AdminCeuComponent extends BasePageComponentDirective<any> implements OnInit {

    ceus: any[] = [];
    ceTypeParams: any = {};
    attendanceTypeParams: any = {};
    constructor(
        injector: Injector,
        private adminService: AdminService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }
    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['title'];
        this.adminService.getUpcomingCEUs(this.pageQuery).then(r => {
            this.ceus = r.content;
            this.page.emit(r);
        });
    }

    override async ngOnInit():Promise<void> {
        super.ngOnInit();
        this.ceTypeParams = await this.parameterService.getParameterByName("CE_TYPE");
        this.attendanceTypeParams = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.query();
    }

    addNew() {
        const dialog = this.dialog.open(AdminAddNewTrainingDialog, {
            data: {
                mode: 'new',
                ceTypes: this.ceTypeParams,
                attendanceTypes: this.attendanceTypeParams
            }
        });
        dialog.componentInstance.result.subscribe(r => {
            this.query();
        })
    }

    editCeu(ceu: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminAddNewTrainingDialog, {
            data: {
                mode: 'edit',
                ceTypes: this.ceTypeParams,
                attendanceTypes: this.attendanceTypeParams,
                ceu: ceu
            },
            width: dialogWidth,
            maxWidth: '100%'
        });
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

    deleteCeu(ceu: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                message: `Deletion of ${ceu.title} by ${ceu.provider}`,
                subMessage: `Are you sure you want to delete "${ceu.title}" from Training list? This action cannot be undone.`,
                theme: 'dark'
            }
        })

        dialog.componentInstance.result.subscribe(r => {
            if (r) {
                this.adminService.deleteCeuEvent(ceu.id).then(_ => {
                    this.query();
                    this.showAlertDark('Delete Training', '', 'Training has been deleted successfully');
                })
            }
        });
    }
}
